import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import { JobsRepository } from '../../repositories';
import { OptimizeJobRequest } from './../../domain/requests/jobs/optimize-job-request';


@Injectable({ providedIn: 'root' })
export class OptimizeJobUsecase implements UseCase<OptimizeJobRequest,boolean> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: OptimizeJobRequest): Observable<boolean> {
    return this.jobRepository.optimizeJob(params);
  }

}
